import CheckInSVG from '@public/icons/icon-reward-check-in.svg'
import RewardSVG from '@public/icons/icon-reward-reward.svg'
import ShopSVG from '@public/icons/icon-reward-shop.svg'
import VestingSVG from '@public/icons/icon-reward-vesting.svg'
import SharedSecNavBar from '@src/components/navigationBar/secondary/SharedSecNavBar'
import { FeatureFlagType } from '@src/constants/featureFlag'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import featureAllowed from '@src/util/apeiron/featureAllowed'
import { FC } from 'react'

const NAVIGATION_ITEMS = featureAllowed(FeatureFlagType.ShowRewardShop)
  ? [
      {
        icon: RewardSVG,
        route: ROUTE.REWARD_LIST,
        translationKey: 'sub_bar.reward.reward'
      },
      {
        icon: VestingSVG,
        route: ROUTE.REWARD_VESTING,
        translationKey: 'sub_bar.reward.vesting'
      },
      {
        icon: CheckInSVG,
        route: ROUTE.REWARD_DAILY_CHECK_IN,
        translationKey: 'sub_bar.rewards.daily_check_in'
      },
      {
        icon: ShopSVG,
        route: ROUTE.REWARD_SHOP,
        translationKey: 'sub_bar.adeptus.shop'
      }
    ]
  : [
      {
        icon: RewardSVG,
        route: ROUTE.REWARD_LIST,
        translationKey: 'sub_bar.reward.reward'
      },
      {
        icon: VestingSVG,
        route: ROUTE.REWARD_VESTING,
        translationKey: 'sub_bar.reward.vesting'
      },
      {
        icon: CheckInSVG,
        route: ROUTE.REWARD_DAILY_CHECK_IN,
        translationKey: 'sub_bar.rewards.daily_check_in'
      }
    ]

const NavigationBar: FC<Props> = (props: Props) => {
  const { index = 0 } = props

  return (
    <SharedSecNavBar
      height={NAV_BAR_CONFIG.secondary.height}
      index={index}
      navigationItems={NAVIGATION_ITEMS}
    />
  )
}

type Props = {
  index: number
}

export default NavigationBar
